/**
 * Returns a moving window of three pages which always includes the current one.
 * @param {number} page Currently selected item
 * @param {number} count Total amount of items
 * @returns {number[]}
 */
export function getNormalPages({ currentPage, totalPages, }) {
    let pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    if (totalPages <= 3)
        return pages;
    const firstPage = 1;
    const lastPage = totalPages;
    if (currentPage === firstPage) {
        pages = [currentPage, currentPage + 1, currentPage + 2];
    }
    else if (currentPage === lastPage) {
        pages = [currentPage - 2, currentPage - 1, currentPage];
    }
    else {
        pages = [currentPage - 1, currentPage, currentPage + 1];
    }
    return pages;
}
//# sourceMappingURL=getNormalPages.mjs.mjs.map